// Los margenes y las tarifas de cobertura que fijo Mike (12-oct). Los numeros
// vienen del servidor (/merchants/pricing-levels): la pantalla no los copia, asi
// el dia que cambien no queda un numero viejo escrito aca.

const SELECT = 'block w-full h-9 px-2 rounded-md border border-slate-200 dark:border-slate-700 dark:bg-slate-900 text-sm';

// Un valor guardado que ya no esta en la lista se muestra tal cual, para que
// guardar otra cosa del setup no lo cambie sin que nadie lo elija.
const fueraDeLista = (value, lista) => value !== '' && value !== null && value !== undefined
  && !lista.includes(Number(value));

export function SelectMargen({ niveles, value, onChange, testid }) {
  const m = niveles?.shipping_markup_pct;
  const todos = m ? [...m.version_1, ...m.version_2] : [];
  return (
    <select className={SELECT} value={value ?? ''} onChange={(e) => onChange(e.target.value)} disabled={!m} data-testid={testid}>
      <option value="">{m ? `Default (${m.default}%)` : 'Loading…'}</option>
      {m && (
        <optgroup label="Version 1">
          {m.version_1.map((v) => <option key={v} value={String(v)}>{v}%</option>)}
        </optgroup>
      )}
      {m && (
        <optgroup label="Version 2">
          {m.version_2.map((v) => <option key={v} value={String(v)}>{v}%</option>)}
        </optgroup>
      )}
      {m && fueraDeLista(value, todos) && <option value={String(value)}>{value}% (not in the list)</option>}
    </select>
  );
}

export function SelectTarifaCobertura({ niveles, value, onChange, testid }) {
  const c = niveles?.coverage_rate_cents;
  return (
    <select className={SELECT} value={value ?? ''} onChange={(e) => onChange(e.target.value)} disabled={!c} data-testid={testid}>
      <option value="">{c ? `Default (${c.default}¢)` : 'Loading…'}</option>
      {c && c.levels.map((v) => <option key={v} value={String(v)}>{v}¢</option>)}
      {c && fueraDeLista(value, c.levels) && <option value={String(value)}>{value}¢ (not in the list)</option>}
    </select>
  );
}

export const notaMargen = (niveles) => {
  const m = niveles?.shipping_markup_pct;
  return m ? `SelleSend's margin on Rate Shop labels. USPS is always ${m.usps}%. WebShip keeps its own price.` : '';
};
